import React from 'react';
import './styles.scss';
import clsx from 'clsx';
import { useCustomComponent } from '@/hooks';

export const DEFAULT_AVATAR_SIZE = '49px';

export type AvatarProps = {
  url: string;
  alt: string;
  height?: string;
  width?: string;
  border?: boolean;
};

const AvatarComponent: React.FC<AvatarProps> = ({
  url,
  alt,
  height = DEFAULT_AVATAR_SIZE,
  width = DEFAULT_AVATAR_SIZE,
  border = true,
}) => {
  return (
    <div className="peptalk-avatar">
      <img
        src={url}
        alt={alt}
        width={width}
        height={height}
        className={clsx(
          'peptalk-avatar-image',
          border && 'peptalk-avatar-image-border'
        )}
      />
    </div>
  );
};

export const Avatar: React.FC<AvatarProps> = (props: AvatarProps) => {
  const Component = useCustomComponent({
    componentName: 'Avatar',
    Component: AvatarComponent,
  });

  return <Component {...props} />;
};
